import { useForm } from "react-hook-form";
import { Stack, Typography, useTheme } from "@mui/material";

import { FormProvider } from "@app/components";
import { Strings } from "@app/constants";

const KmDriven = ({ methods }: any) => {
  const theme = useTheme();

  const KmDriven = methods.watch("KmDriven");
  const data = [
    { drive: "0Km - 10,000Km" },
    { drive: "10,000Km - 20,000Km" },
    { drive: "20,000Km - 30,000Km" },
    { drive: "30,000Km - 40,000Km" },
    { drive: "40,000Km - 50,000Km" },
    { drive: "50,000Km - 60,000Km" },
    { drive: "60,000Km - 70,000Km" },
    { drive: "70,000Km - 80,000Km" },
    { drive: "80,000Km - 90,000Km" },
    { drive: "90,000Km - 1,00,000Km" },
    { drive: "1,00,000Km+" },
  ];
  return (
    <>
      <Stack flexDirection={"column"} py={2}>
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {Strings.step.kmDriven.howFarHasItTravelled}
          </Typography>
          <Typography variant="body1" sx={{ color: theme.palette.grey[500] }}>
            {Strings.step.kmDriven.enterYourOdometerReading}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        sx={{
          mt: { xs: 3, sm: 5 },
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 2,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {data?.map((item, index) => (
          <Stack
            key={index}
            onClick={() =>
              methods.setValue("KmDriven", item.drive, { shouldValidate: true })
            }
            sx={{
              px: 3,
              py: 1.5,
              border: 1,
              minWidth: 225,
              borderRadius: 2,
              cursor: "pointer",
              borderColor:
                KmDriven === item.drive
                  ? theme.palette.primary.main
                  : theme.palette.common.black,
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              backgroundColor:
                KmDriven === item.drive
                  ? theme.palette.primary.main
                  : "transparent",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                color:
                  KmDriven === item.drive
                    ? theme.palette.common.white
                    : theme.palette.grey[900],
              }}
            >
              {item.drive}
            </Typography>
          </Stack>
        ))}
      </Stack>
      {methods.formState.errors?.KmDriven && (
        <Typography color="error" textAlign="center" mt={2}>
          {methods.formState.errors.KmDriven.message}
        </Typography>
      )}
    </>
  );
};

export { KmDriven };
